import { Box } from '@mui/material';
import useIsMobile from 'hooks/useIsMobile';
import { EarningsChart } from 'components/resources/EarningsChart/EarningsChart';

export const Earnings = () => {
  const isMobile = useIsMobile();
  return (
    <Box
      sx={{
        width: isMobile ? '100vw' : '800px',
        height: isMobile ? '65vh' : '650px',
        alignSelf: 'flex-start',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <EarningsChart />
    </Box>
  );
};
